export default 'M4.59 8.41a2 2 0 1 0 2.82 2.83L10 8.66V21a2 2 0 0 0 4 0V8.66l2.59 2.58a2 2 0 1 0 2.82-2.83L12 1z';